import React, { useState } from "react";
import { i18n } from "../../translate/i18n";
import { Avatar, CardHeader } from "@material-ui/core";
import maskPhoneLast4 from "../../utils/maskPhoneLast4";

const TicketInfo = ({ contact, ticket, onClick }) => {
	const [amount, setAmount] = useState("");

	const renderCardReader = () => {
		return (
			<CardHeader
				onClick={onClick}
				style={{ cursor: "pointer", padding: "8px 0", overflow: "hidden" }}
				titleTypographyProps={{ noWrap: true, style: { fontSize: 14 } }}
				subheaderTypographyProps={{ noWrap: true, style: { fontSize: 11 } }}
				avatar={<Avatar src={contact?.urlPicture} alt="contact_image" />}
				title={`${maskPhoneLast4(contact?.name) || i18n.t("tickets.noContactName")} #${ticket.id}`}
				subheader={
					ticket.user &&
					`${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`
				}

			/>
		);
	}

	const handleChange = (event) => {
		const value = event.target.value;

		setAmount(value);
	}


	return (
		<div style={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
			{renderCardReader()}
		</div>
	);
};

export default TicketInfo;
